module.exports = __webpack_public_path__ + "img/62.27b057ad.jpg";